/** Toasts should be automatically removed after 5 seconds */
export const DEFAULT_TOAST_TIMEOUT = 5 * 1000;
